"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPlainIconButton = exports.StyledIcon = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _iconElement = require("../../fuse-icon-element/src/icon-element");
var _tappablearea = require("../../fuse-tappable-area/src/tappablearea");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledPlainIconButton = exports.StyledPlainIconButton = _styledComponents["default"].button.attrs({
  className: 'fuse-plain-icon-button'
}).withConfig({
  displayName: "styled-plain-icon-button__StyledPlainIconButton",
  componentId: "sc-nn96ce-0"
})(["background:none;border:none;display:inline-flex;margin:0;padding:0;position:relative;&:active,&:focus{", "}&:hover,&:focus{color:var(--color-brand-dark);cursor:pointer;}&:active{color:var(--color-global-black);}&:focus .fuse-plain-icon-button__icon,&:hover .fuse-plain-icon-button__icon{background:var(--color-brand-dark);}&:active .fuse-plain-icon-button__icon{background:var(--color-global-black);}&[disabled]{color:var(--color-global-grey400);background-color:unset;border:none;cursor:auto;}&[disabled] .fuse-plain-icon-button__icon{background-color:var(--color-global-grey400);}", ""], _fuseUtils.FocusCss, _tappablearea.TappableArea);
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_iconElement.Icon).attrs({
  className: 'fuse-plain-icon-button__icon',
  'data-testid': 'fuse-plain-icon-button-icon-test-id'
}).withConfig({
  displayName: "styled-plain-icon-button__StyledIcon",
  componentId: "sc-nn96ce-1"
})([""]);